module.exports = __webpack_public_path__ + "img/edit-02.f9f31bf2.svg";